const STORAGE_KEY_PREFIX = 'email-signup-success-';

document.querySelectorAll('[data-email-signup]').forEach((root) => {
  if (!(root instanceof HTMLElement)) return;
  const form = root.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', () => {
    sessionStorage.setItem(STORAGE_KEY_PREFIX + root.dataset.emailSignup, Date.now().toString());
  });
});

window.addEventListener('load', () => {
  document.querySelectorAll('[data-email-signup]').forEach((root) => {
    if (!(root instanceof HTMLElement)) return;
    const key = STORAGE_KEY_PREFIX + root.dataset.emailSignup;
    const ts = sessionStorage.getItem(key);
    if (!ts) return;

    sessionStorage.removeItem(key);

    // Discard if more than 2 minutes have passed (e.g. CAPTCHA failure/timeout)
    if (Date.now() - Number(ts) > 120_000) return;

    const fieldsEl = root.querySelector('[data-email-signup-fields]');
    const successEl = root.querySelector('[data-email-signup-success]');

    // Server reported an error — leave form visible, don't show success
    if (fieldsEl?.hasAttribute('data-has-error')) return;

    fieldsEl?.setAttribute('hidden', '');
    successEl?.removeAttribute('hidden');
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Re-scroll for anchor-based redirects where footer loads late
  const hash = window.location.hash;
  if (hash) {
    const target = document.getElementById(hash.slice(1));
    if (target?.classList.contains('email-signup-block')) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
});
